<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="tab-grid">
          <div
            v-for="(item, i) in tabs"
            :key="i"
            class="tab-pill"
            :class="{ active: tab === i }"
            @click="tab = i"
          >
            {{ item }}
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- ROTACIÓN -->
    <v-row dense align="center" class="mt-5">
      <v-col cols="4" class="control-label">
        Rotación
      </v-col>
      <v-col cols="8">
        <v-slider
          v-model="rotationSelected"
          min="0"
          max="360"
          step="1"
          dense
          hide-details
          class="custom-slider"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-tabs-items v-model="tab">
          <v-tab-item
            v-for="(config, index) in tabConfig"
            :key="index"
          >
            <!-- Grid de iconos -->
            <SymbologyIconGrid
              :lists="config.iconLists"
              :active-key="activeBtn"
              @select="paintImageIcon"
              class="px-0"
            />

            <!-- Extra opcional -->
            <v-checkbox
              v-if="config.extra === 'medio'"
              v-model="medio_externo"
              dark
              dense
              label="Medio externo"
              style="margin-left: 12px"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SymbologyIconGrid from '@/components/map/symbology/SymbologyIconGrid.vue'
import { mapGetters } from 'vuex'
import * as ArcGIS from '@/helpers/ArcGIS'

export default {
  components: { SymbologyIconGrid },

  data: () => ({
    tab: 0,
    tabs: [
      'Medios',
      'Riesgos',
      'Defensa',
      'Instalaciones',
      'Accesibilidad',
      'Escenario',
      'SITAC'
    ],
    activeBtn: null,
    medio_externo: false,
    rotationSelected: 0
  }),

  computed: {
    ...mapGetters('map', [
      'symbologyMedios',
      'symbologyRiesgos',
      'symbologyDefensa',
      'symbologyInstalaciones',
      'symbologyAccesibilidad',
      'symbologyEscenario',
      'symbologySitac',
      'symbologySitac2',
      'symbologyDivisoria',
      'symbologyVaguada',
      'symbologyLinesSITAC',
      'symbologyLines',
      'symbologyLinesEscenario',
      'symbologyPolygons'
    ]),

    tabConfig() {
      return [
        {
          iconLists: [this.symbologyMedios],
          extra: 'medio'
        },
        {
          iconLists: [this.symbologyRiesgos]
        },
        {
          iconLists: [this.symbologyDefensa]
        },
        {
          iconLists: [this.symbologyInstalaciones]
        },
        {
          iconLists: [this.symbologyAccesibilidad]
        },
        {
          iconLists: [
            this.symbologyEscenario,
            this.symbologyDivisoria,
            this.symbologyVaguada
          ]
        },
        {
          iconLists: [
            this.symbologySitac,
            this.symbologySitac2
          ]
        }
      ]
    }
  },

  methods: {
    paintImageIcon(symbol) {
      this.isDrawing = true
      this.activeBtn = symbol.src

      const event = {
        function: 'icon',
        src: symbol.img, // TODO: aqui se pasa el BASE64 de la imagen y es lo que se guarda en base de datos, mirar como pasar la url del fichero
        tipo: symbol.type ? symbol.type : undefined,
        medio_externo: this.medio_externo && symbol.position === 13, // Chapuza para no mostrar el cirulo negro en las descargas.
        label: symbol.label,
        showBackground: symbol.position === 13,
        rotation: this.rotationSelected
      }

      this.paint(event)
      this.$emit('selected', this.isDrawing)
    },

    clickEsriSymbol(evt) {
      this.isDrawing = true
      this.activeBtn = `${evt}Button`
      this.paintEsriSymbol(evt)
      this.$emit('selected', this.isDrawing)
    },

    paint(event) {
      this.isDrawing = true
      this.$emit('paint', event)
    }
  }
}
</script>

<style scoped>
::v-deep .v-tabs-items {
  background: transparent !important;
}

.tab-grid {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  overflow-x: auto;
}

.tab-pill {
  flex: 1;
  text-align: center;
  padding: 2px 4px;
  font-size: 10px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  border: 1px solid #e0e0e0;
  color: #537582;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-pill:hover {
  background: #f3f6f7;
}

.tab-pill.active {
  background: #34515C;
  color: white;
  border-color: #34515C;
}

.control-label {
  font-size: 12px;
  opacity: 0.8;
  color: white;
}

.custom-slider {
  margin-top: 6px;
  margin-left: 6px;
}

.custom-slider >>> .v-slider__track-background {
  background-color: rgba(255,255,255,0.2);
}

.custom-slider >>> .v-slider__track-fill {
  background-color: white;
}

.custom-slider >>> .v-slider__thumb {
  background-color: white;
}

</style>
